import { useRef } from 'react';
import { useCursorTrail } from '../hooks/useCursorTrail';

export function CypherpunkCursor() {
  const cursorRef = useRef(null);
  const canvasRef = useRef(null);

  useCursorTrail(canvasRef, cursorRef);

  return (
    <>
      {/* Trail canvas */}
      <canvas
        ref={canvasRef}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          pointerEvents: 'none',
          zIndex: 99997,
        }}
      />

      {/* Crosshair SVG */}
      <div
        ref={cursorRef}
        data-testid="cypherpunk-cursor"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: 24,
          height: 24,
          pointerEvents: 'none',
          zIndex: 99999,
          transform: 'translate(-200px, -200px)',
          filter: 'drop-shadow(0 0 5px rgba(255, 234, 0, 0.9))',
        }}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <line x1="12" y1="0" x2="12" y2="8.5" stroke="#FFEA00" strokeWidth="1.5" />
          <line x1="12" y1="15.5" x2="12" y2="24" stroke="#FFEA00" strokeWidth="1.5" />
          <line x1="0" y1="12" x2="8.5" y2="12" stroke="#FFEA00" strokeWidth="1.5" />
          <line x1="15.5" y1="12" x2="24" y2="12" stroke="#FFEA00" strokeWidth="1.5" />
          <circle cx="12" cy="12" r="2.5" stroke="#FFEA00" strokeWidth="1.5" fill="rgba(255, 234, 0,0.2)" />
        </svg>
      </div>
    </>
  );
}
